<div class="alerts-main">
  <div class="alerts-list">
    <nav class="alerts-list__tabs" role="tablist">
      <button
        *ngFor="let tab of alertTabs; let i = index"
        type="button"
        role="tab"
        class="alerts-list__tab"
        [class.alerts-list__tab--active]="selectedTabIndex === i"
        (click)="onTabSelection(i)"
      >
        {{ tab.label }}
      </button>
    </nav>

    <p class="alerts-list__subtitle">
      <ng-container *ngIf="selectedTabIndex === 0">
        Set up alerts to be notified when scores cross thresholds or major
        events happen.
      </ng-container>
      <ng-container *ngIf="selectedTabIndex === 1">
        Set up reports to analyze scores and identify top and low performers in
        your portfolio or a single entity.
      </ng-container>
    </p>

    <ng-container *ngIf="!loadingAlerts && selectedTabIndex === 0">
      <app-alerts-accordion
        [scoreAlerts]="alerts | filterBy: ['alert_category'] : 'scores'"
        [eventAlerts]="alerts | filterBy: ['alert_category'] : 'events'"
        [expanded]="expandedAlertCategories"
        [currentAlertUid]="currentAlert?.uid ?? null"
        (toggleSection)="onToggleSection($event)"
        (selectAlert)="selectAlert($event)"
        (createAlertInCategory)="createAlertInCategory($event)"
        (toggleActive)="onSlideToggle($event.checked, $event.alert)"
      ></app-alerts-accordion>
    </ng-container>

    <ng-container *ngIf="selectedTabIndex === 1">
      <app-reports-settings [scoreOptions]="scoreTypes"></app-reports-settings>
    </ng-container>
  </div>

  <div class="alerts-settings" *ngIf="selectedTabIndex === 0">
    <ng-container *ngIf="!loadingAlerts">
      <div class="alerts-settings-container">
        <div class="settings-container-contents">
          <div class="alerts-section-header">{{ formTitle }}</div>

          <mat-form-field appearance="outline" class="field-type">
            <mat-label>Name</mat-label>
            <input
              matInput
              placeholder="Create alert's name *"
              required
              [(ngModel)]="currentAlert.name"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="field-type">
            <mat-label>Additional Recipients from {{ domain }}</mat-label>
            <mat-chip-list
              #chipListAlertRecipients
              aria-label="Email selection"
            >
              <mat-chip
                *ngFor="let item of emailList"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(item)"
              >
                {{ item }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input
                matInput
                [matChipInputFor]="chipListAlertRecipients"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="add($event)"
              />
            </mat-chip-list>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="field-type"
            *ngIf="selectedAlertCategory === 'scores'"
          >
            <mat-label>Schedule</mat-label>
            <mat-select
              #selectorAlertSchedule
              [(ngModel)]="currentAlert.schedule"
              required
            >
              <mat-option value="1d">Check alert's triggers daily</mat-option>
              <mat-option value="1w">Check alert's triggers weekly</mat-option>
              <mat-option value="30d"
                >Check alert's triggers monthly</mat-option
              >
              <mat-option value="once"
                >Send alert only once and deactivate</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="field-type"
            *ngIf="selectedAlertCategory === 'scores'"
          >
            <mat-label>Channel</mat-label>
            <mat-select
              #selectorAlertChannel
              [(ngModel)]="currentAlert.layout"
              required
              (selectionChange)="onChannelChange()"
            >
              <mat-option value="digest">Digest - Email</mat-option>
              <mat-option value="explainable_digest"
                >Detailed Digest - Email</mat-option
              >
            </mat-select>
          </mat-form-field>

          <p>Alert Type *</p>
          <mat-radio-group
            #selectorAlertType
            [(ngModel)]="currentAlert.alert_type"
            (change)="optSelect2()"
            required
          >
            <mat-radio-button value="entity">Entity</mat-radio-button>
            <mat-radio-button value="portfolio">Portfolio</mat-radio-button>
          </mat-radio-group>

          <p>Choose the object to set-up an alert for</p>

          <mat-form-field
            appearance="outline"
            class="field-search"
            *ngIf="currentAlert.alert_type === 'portfolio'"
          >
            <mat-label>Name</mat-label>
            <mat-select
              #selectorAlertObject
              [(ngModel)]="currentAlert.object_id"
              (selectionChange)="optSelect3($event, 'portfolio')"
              required
            >
              <mat-option
                *ngFor="let option of folio$ | async | orderBy: 'name'"
                [value]="option.uid"
                [disabled]="option.content.length === 0"
                >{{ option.name
                }}{{
                  option.content.length === 0 ? ' (Portfolio is empty)' : ''
                }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="field-search"
            *ngIf="currentAlert.alert_type === 'entity'"
          >
            <mat-label>Search</mat-label>
            <input
              #inputAlertObject
              matInput
              type="text"
              [matAutocomplete]="menuSearch"
              [formControl]="searchFormControl"
              required
            />

            <mat-autocomplete
              #menuSearch="matAutocomplete"
              (optionSelected)="optSelect($event.option.value)"
              [autoActiveFirstOption]="true"
              class="searchLetter search-panel"
              panelWidth="auto"
            >
              <div *ngIf="searchResults as search">
                <div
                  *ngFor="
                    let items of search.hits
                      | groupBy: 'entity.type'
                      | orderByType
                      | pairs
                  "
                >
                  <mat-optgroup>
                    <div class="optgroup-search">
                      <div class="indexo-left">{{ items[0] | nicetxt }}</div>
                      <div class="indexo-right">
                        <div class="optgroup-column column-1">Country</div>
                        <div class="optgroup-column"># Articles</div>
                      </div>
                    </div>
                    <ng-container *ngFor="let option of items[1]">
                      <mat-option
                        *ngIf="!option.entity.hasParent"
                        [value]="option"
                      >
                        <div class="search-indexo">
                          <div class="indexo-left">
                            <span>{{ option.entity.name }}</span>
                            <span class="match">{{
                              option.entity.matched_form
                                ? option.entity.matched_form
                                : ''
                            }}</span>
                          </div>
                          <div class="indexo-right">
                            <div class="optgroup-column column-1">
                              {{
                                option.entity &&
                                option.entity.country &&
                                option.entity.country.alpha_id
                                  ? option.entity.country.alpha_id.toUpperCase()
                                  : '\u2014'
                              }}
                            </div>
                            <div class="optgroup-column">
                              {{ numberFormat(option.count) }}
                            </div>
                          </div>
                        </div>
                      </mat-option>
                      <mat-option
                        *ngFor="let optionChild of option.entity.children"
                        [value]="optionChild"
                      >
                        <div class="search-indexo">
                          <div class="indexo-left">
                            <span class="subsidiary">{{
                              optionChild.entity.name
                            }}</span>
                            <span
                              class="match"
                              *ngIf="iMatch(optionChild.entity)"
                              >{{
                                optionChild.entity.matched_form
                                  ? optionChild.entity.matched_form
                                  : ''
                              }}</span
                            >
                          </div>
                          <div class="indexo-right">
                            <div class="optgroup-column column-1">
                              {{
                                optionChild.entity &&
                                optionChild.entity.country &&
                                optionChild.entity.country.alpha_id
                                  ? optionChild.entity.country.alpha_id.toUpperCase()
                                  : '\u2014'
                              }}
                            </div>
                            <div class="optgroup-column">
                              {{ numberFormat(optionChild.count) }}
                            </div>
                          </div>
                        </div>
                      </mat-option>
                    </ng-container>
                  </mat-optgroup>
                </div>
              </div>
            </mat-autocomplete>
            <mat-spinner [diameter]="15" *ngIf="loading"></mat-spinner>
          </mat-form-field>

          <app-score-alerts
            *ngIf="selectedAlertCategory === 'scores'"
            [triggers]="currentAlert.triggers"
            [alertType]="currentAlert.alert_type"
            [layout]="currentAlert.layout"
            [scoreTypes]="scoreTypes"
            [thresholdSettingTypes]="thresholdSettingTypes"
            [selectedDeltaPeriod]="selectedDeltaPeriod"
            [deltaPeriods]="deltaPeriods"
          ></app-score-alerts>

          <app-event-alerts
            *ngIf="selectedAlertCategory === 'events'"
            [currentAlert]="currentAlert"
            [scoreEventsTypes]="scoreEventsTypes"
            (fieldSeen)="onFieldSeen()"
          ></app-event-alerts>
        </div>
        <!--<div class="settings-container-actions" *ngIf="currentScoreType !== 'yukka'"></div>-->
      </div>
      <div class="alerts-settings-footer">
        <button
          id="delete-alert"
          class="delete"
          mat-button
          *ngIf="currentAlert.uid"
          (click)="deleteAlert()"
          [class.delete-warning]="isButtonActive"
          (mouseover)="isButtonActive = true"
          (mouseout)="isButtonActive = false"
        >
          <mat-icon>delete</mat-icon>
          <span>DELETE</span>
        </button>

        <button
          id="save-alert"
          class="save"
          [class.valid-alert]="
            isValidAlert(currentAlert, false) &&
            ((fieldsSeen && selectedAlertCategory === 'events') ||
              selectedAlertCategory === 'scores')
          "
          mat-button
          (click)="saveAlert(currentAlert.active, null)"
        >
          <mat-icon>save</mat-icon>
          <span>SAVE</span>
        </button>
      </div>
    </ng-container>
  </div>
  <div class="reports-pane" *ngIf="selectedTabIndex === 1">
    <header class="reports-pane__header">
      <span class="reports-pane__badge">Subscription report</span>
      <h2 class="reports-pane__title">{{ reportHeaderTitle }}</h2>
    </header>
    <app-report-overview [bullets]="reportBullets"></app-report-overview>
    <app-reports-form
      [scoreOptions]="scoreTypes"
      (titleChange)="reportHeaderTitle = $event"
      (bulletsChange)="reportBullets = $event"
    ></app-reports-form>
  </div>
</div>
